/* eslint-disable */
import React from 'react';

class ShadowWrapper extends React.Component {
    render() {
        return this.props.children;
    }
}

const Show = props => {
    if (props.if || false) {
        return <ShadowWrapper>{props.children}</ShadowWrapper>;
    }
    return null;
};

export default Show;
